<nav class="navbar navbar-expand-lg navbar-absolute fixed-top nav-style ">
  <div class="container-fluid">

    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <!-- <a class="navbar-brand primary-color-white primary-font-size p-3 mt-1" href="javascript:void(0)">{{getTitle()}}</a> -->
    </div>


    <button class="navbar-toggler" type="button" (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav">
        <li class="nav-item">
           <!--<a class="nav-link btn-rotate">
            <div class="table-search-container">
              <span class="fa fa-search table-search-icon"></span>
              <input class="table-search-input" (keydown.enter)="onSearch($event)" type="text" placeholder="Search">
            </div>
          </a>
        </li>-->
        <li class="nav-item btn-rotate" ngbDropdown placement="bottom-left">
          <!-- <a class="nav-link" ngbDropdownToggle id="navbarDropdownMenuLink" >
            <i class="nc-icon nc-settings-gear-65"></i> 
            <p>
              <span class="d-lg-none d-md-block"></span>
            </p>
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu dropdown-menu-right">
            <a ngbDropdownItem href="javascript:void(0)" (click)="onClickLogout()">Logout</a>
          </div> -->
        </li>
      </ul>
    </div>

  </div>  
</nav> 
